import { PageMetaProps } from '@psl/appComponents/seo/PageMeta.shared';
import { useIsFocused } from '@react-navigation/native';
import { FC, memo, useEffect } from 'react';

export const kDefaultPageTitle =
  'Popshoplive - Shop & Sell - Latest trends in Fashion & Collectibles';

export const kDefaultPageDescription =
  'Popshoplive is a turnkey creator commerce platform where creators sell ' +
  'their favorite items to their followers through e.commerce, video clips ' +
  'and live-streamed shows.';

export const PageMeta: FC<PageMetaProps> = memo(({ title, description }) => {
  const isFocused = useIsFocused();
  return isFocused ? (
    <>
      <Meta name="title" content={title} />
      <Meta name="description" content={description} />
      <Meta name="og:title" content={title} />
      <Meta name="og:description" content={description} />
      <Meta name="twitter:title" content={title} />
      <Meta name="twitter:description" content={description} />
    </>
  ) : null;
});

const Meta = memo(
  ({ name, content }: { name: string; content: string | undefined }) => {
    useEffect(() => {
      if (content == null) {
        return;
      }

      const cleanups: (() => void)[] = [];

      if (name === 'title') {
        const prevTitle = document.title;
        document.title = content;
        cleanups.push(() => {
          document.title = prevTitle;
        });
      }

      const attr = name.startsWith('og:') ? 'property' : 'name';

      const titleEl = document.querySelector('title') as HTMLTitleElement;
      let el = document.querySelector(
        `meta[${attr}="${name}"]`,
      ) as HTMLMetaElement | null;
      if (el) {
        const prev = el.getAttribute('content');
        el.setAttribute('content', content);
        cleanups.push(() => {
          el?.setAttribute('content', prev ?? '');
        });
      } else {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        el.setAttribute('content', content);
        titleEl.insertAdjacentElement('afterend', el);
        cleanups.push(() => {
          titleEl.removeChild(el!);
        });
      }

      return () => {
        cleanups.forEach(f => f());
      };
    }, [content, name]);
    return null;
  },
);
